import { TagRequest } from '@/models/Tag';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { Tags, TagTypes } from './types';

export const getTagsRequest = (data: TagRequest) => action(TagTypes.GET_TAGS_REQUEST, data);
export const getTagsSuccess = (data: Tags) => action(TagTypes.GET_TAGS_SUCCESS, data);
export const getSuggestionTagsSuccess = (data: Tags) => action(TagTypes.GET_SUGGESTION_TAGS_SUCCESS, data);
export const getTagsClear = () => action(TagTypes.GET_TAGS_CLEAR);
export const getTagsFailure = (error: AxiosError) => action(TagTypes.GET_TAGS_FAILURE, error);
